import React from "react";
import { SEO, Login, MainLayout } from "../../../components";

const LoginPage = () => {
  return (
    <>
      <SEO title="login" />
      <MainLayout>
        <Login />
      </MainLayout>
    </>
  );
};

export default LoginPage;
